<template>
    <social></social>
</template>

<script>
import Social from '../Social'

export default {
    components: {
        'social': Social
    }    
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaSocial.vue